export enum AdSlot {
    'DESKTOP' = 'E_Resultlist_Disturber_Ad_1',
    'MOBILE' = 'E_Mobile_Ad',
    'GALLERY_1' = 'E_Gallery_Disturber_Ad_1',
    'GALLERY_2' = 'E_Gallery_Disturber_Ad_2',
    'GALLERY_3' = 'E_Gallery_Disturber_Ad_3',
}

export enum expanderBox {
    DESCRIPTION = 'beschreibung',
    EQUIPMENT = 'ausstattung',
    LOCATION = 'lage',
    AVAILABILITY = 'verfügbarkeit',
    OTHERS = 'sonstiges',
}

export enum MsAccordionTrackingVariant {
    COSTS = 'kosten',
    ENERGIES = 'energieversorgung',
    OBJECT_INFO = 'wohnungsdetails',
}
